<template>
    <footer id="bottom-menu">

        <div id="parent-box" >
            <div id="box-contacto">

                <div class="contenedor-logo">
                    <img class="logo" src="../../../assets/paginaoficial/Logotipo_Negativo_Vertical.png" />
                </div>

                <div v-for="menu in menus" v-bind:key="menu.MenuId" class="contenedor-ligas"
                    style="width: 70%; padding: 2em;">

                    <p style="color:white" class="enMayusculas">{{ menu.Titulo }}</p>
                    <div class="row col-md-12 col-12 h-50 w-100">
                        <ul class="disminuir-fuente row h-100 w-100">
                            <li style="color:white" class="col-12 col-md-6" v-for="submenu in menu.Submenus"
                                v-bind:key="submenu.SubmenuId">
                                <a v-if="!submenu.SeMuestraEnVisor" :href="submenu.RutaParaAccesar" target="blank"
                                    class="sitios-interes">{{ submenu.Titulo }}eessss</a>
                                <a v-if="submenu.SeMuestraEnVisor" @click="AbreElVisor(submenu.RutaParaAccesar)"
                                    target="blank" class="sitios-interes">{{ submenu.Titulo }}sss</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div v-if="PAGINA_DE_INICIO == 17" id="box-codigo-qr">

                <!--<label style="color: white; text-align: justify; font-size: 1rem; font-family: Myriad; margin: 0; max-width: 140px; line-height: 1.3; border: black;">
                            <strong>Escanea y obtén el formato para presentar tu denuncia.</strong>
                        </label>-->
                <div class="box-qr">
                    <div>

                        <h4>¡Escanea el código QR!</h4>
                        <p style="font-size: 1.1em;">
                            Obtén fácilmente el formato para presentar tu denuncia.
                        </p>

                        <div style="font-size: 2em;display: flex; align-items: center; justify-content: end;">
                            <i class="far fa-hand-point-right"></i>
                        </div>

                    </div>
                    <div>


                        <div style="background-color: white; padding: .5em;">
                            <img style="width: 7em; height: 7em;" class="logo"
                                :src="enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos + '/Micrositios/TribunalDiciplinaJudicial/qr_formulario_tribunal_diciplina.jpeg'" />
                        </div>
                    </div>
                </div>


            </div>



            <!-- <div class="col-1 col-md-6 align-item-right" style="height: 2em;">
                    <ul class="vertical-center">
                        <li style="color:white" class="Myriad"><i class="fas fa-copyright"></i>&nbsp;{{ anio }} - Todos
                            los derechos reservados.</li>
                    </ul>
                </div> -->
        </div>
        <div style="display:flex; height:5em;  color: white; font-size: 1.4em; justify-content: center; align-items: end;">
            <p class="Myriad"><i class="fas fa-copyright"></i>&nbsp;{{ anio }} - Todos los derechos reservados.</p>
        </div>

    </footer>
</template>

<script>
import enumeraciones from "@/../static/js/enumeraciones";
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
import api from "@/../static/js/api";
import axios from "axios";

export default {
    data() {
        return {
            enumeraciones,
            anio: '',
            enumeraciones_sicpo,
            PAGINA_DE_INICIO: 6,
            TIPO_POSICION: 2,
            menus: [],
            nombreDeVariableDelComponente: "cargoMenuInferior"
        };
    },
    computed: {
        existeAlgunMenuSeleccionado: function () {
            let seAbreElMenu = false;
            console.log(">>>>existeAlgunMenuSeleccionado this.menu:", this.menu);
            if (this.menus.length > 0) {
                this.menus.forEach(menu => {
                    if (menu.Mostrar == true)
                        seAbreElMenu = true;
                })
            }

            return seAbreElMenu;
        },
        idPaginaInicial: function () {
            console.log(">>>>existeAlgunMenuSeleccionado idPaginaInicial:", this.$store.getters.Get_PaginaInicial_Micrositio);
            return this.$store.getters.Get_PaginaInicial_Micrositio;
        }

    },
    methods: {
        AbreElVisor: function (vinculo) {
            this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo);
        },
        async CargaMenu() {
            var paginaRoute = this.$store.getters.Get_SICPO_Micrositio_MenuRuta;
            console.log(">>>>CargaMenu paginaRoute: ", paginaRoute)
            console.log(">>>>CargaMenu PAGINA_DE_INICIO: ", this.PAGINA_DE_INICIO)
            this.PAGINA_DE_INICIO = paginaRoute == "/Micrositio/TD/Home" ? 17 : this.PAGINA_DE_INICIO;
            let peticion = {
                Url: paginaRoute,
                conSubmenus: true,
                tipoPosicion: 2,
                conSoloSubmenusActivos: true,
                EsPrueba: enumeraciones.EsPrueba
            }
            axios.post(api.conexion + api.SICPO.sistema.micrositioweb.oficialmicrositio.ObtenLosMenusYSubmenusDeMicrositio, peticion).
                then(async response => {
                    if (response.data.SiHayError) {
                        this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Error);

                    } else {
                        this.menus = response.data.MenuMicrositio.menus;
                        this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Cargado);

                    }

                }).catch(e => {
                    console.log('Error de Pagina: ' + e)
                    this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Error);
                });
        },
        CargaElMenu: function () {

            let parametros = {
                EsPrueba: this.enumeraciones.EsPrueba,
                PaginaDeInicioId: this.idPaginaInicial,
                TipoPosicionId: this.TIPO_POSICION
            }
            console.log(">>>>MenuInferior Parameters:", parametros)
            axios
                .post(api.conexion + api.SICPO.sistema.paginaweb.paginaoficial.ObtenLosMenusYSubmenusDeLaPaginaOficial, parametros)
                .then(respuesta => {
                    if (respuesta.data.SiHayError) {
                        this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Error);
                    } else {

                        this.menus = respuesta.data.Menus;
                        this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
                    }
                })
                .catch(excepcion => {
                    console.error(excepcion);
                    this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Error);
                });
        },
        YaTermineDeCargar: function (estatus) {
            this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, estatus);
        }
    },
    mounted() {
        this.CargaMenu();
        this.anio = moment().format('YYYY');
    }
}
</script>

<style scoped>
#box-contacto {
    display: flex;

}

.box-qr {
    color: white;
    text-align: justify;
    font-size: 1.5em;
    font-family: Myriad;
    line-height: 1.3;
    border: 2px solid whitesmoke;
    padding: 6px 12px;
    border-radius: 10px;
    display: flex;
    gap: 1em;
    background-color: hsl(179 100 31);
    align-items: center;
    margin-right: 2em;
}

#parent-box {
    height: auto;
    display: flex;

}

.sitios-interes {
    font-family: 'AntenaBeta';
    font-size: 14px;
}

li:hover {
    color: #be9a5e;
}

.logo {
    width: 8vw;
    height: 15vh;
}

#bottom-menu {
    z-index: 9 !important;
    background-color: rgb(0, 117, 115);

}

.enMayusculas {
    text-transform: uppercase;
    font-family: 'AntenaBeta';
}

.AntenaBeta {
    font-family: 'AntenaBeta';

}

.Myriad {
    font-family: 'Myriad';
    margin-right: 30px;
}

#inferior-menu {
    /* display: flex; */
    align-items: center;
    height: auto;
    font-size: 18px;
    background-color: rgb(0, 117, 115);
    /* z-index: 10 !important; */
    position: relative;
}

#inferior-menu div {
    height: 100%;
    /* background-color: rgb(128, 19, 19); */
}

a {
    color: #FFFFFF;
    margin-right: 0px;
}

a:hover {
    color: #be9a5e;
}

.separador {
    border-right: 2px solid white;
    padding-right: 0 !important;
}

.contenedor {
    position: relative;

}

.contenedor-ligas {
    position: relative;
}


.contenedor-logo {
    width: 20%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.contenedor-caja-QR {
    min-height: 200px;
    min-width: 200px;
}

.vertical-center {
    margin: 0;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    position: absolute;
    list-style: none;
}

img {
    width: 75%;
}

.disminuir-fuente {
    font-size: .7rem;
}

p {
    margin-top: 10px;
}

.align-item-right {
    margin-top: auto;
    display: flex;
    margin-left: auto;
    justify-content: flex-end;
}

.align-item-right-QR {
    margin-top: auto;
    display: flex;
    margin-left: 600px;
    justify-content: flex-end;
    max-width: 1550px;
    max-height: 1550px;
}

#inferior-menu .row {
    margin-left: 1 !important;
    margin-right: 1 !important;
}

#inferior-menu [class*="col-"] {
    padding-left: 1 !important;
    padding-right: 1 !important;
}

#box-codigo-qr {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40vw;
}

@media only screen and (max-width:1060px) {
    #parent-box {
        flex-direction: column;

    }

    .logo {
        width: 2;
    }

    #box-codigo-qr {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100vw;
    }

    #box-contacto {
        width: 100vw;
    }

}

@media only screen and (max-width:768px) {
    .logo {
        width: 20%;
    }

    .separador {
        border-right: none;
    }


    .contenedor-logo {
        text-align: center;
        height: 60% !important;
        right: 40px;
        display: none;
    }

    .contenedor {
        position: relative;

    }

    .contenedor-ligas {
        margin-left: 1em;
    }

    .contenedor-caja-QR {
        min-height: 200px;
        min-width: 200px;
        text-align: center;
        height: 60% !important;
        right: 40px;
    }

}


@media (max-width: 600px) {
    .logo {
        width: 30%;

    }

    .separador {
        border-right: none;
    }

    .contenedor-logo {
        text-align: center;
        height: 60% !important;
        right: 40px;
        display: none;
    }

    .contenedor-caja-QR {
        min-height: 200px;
        min-width: 200px;
        text-align: center;
        height: 60% !important;
        right: 40px;
    }

    .contenedor-ligas {
        margin-left: 1em;
    }


}
</style>



// WEBPACK FOOTER //
// src/components/Micrositios/Comun/MenuInferiorMicrositio.vue